<template>
<div class="grid-content">
    <div class="training-type-area">
        <div v-if="!isEditName && !readonly"> <span class="input-width" @dblclick="onEditTypeName">{{this.trainingCategoryModel.Name}}</span>
            <el-button size="medium" type="text" icon="el-icon-plus" @click="addMainCourse">添加{{mainCourseName}}</el-button>
            <el-button size="medium" type="text" icon="el-icon-delete" class="delete-button" @click="deleteCategory">删除</el-button>
        </div>
        <div v-if="isEditName">
            <el-form ref="trainingCategoryForm" :model="trainingCategoryModel" :rules="rules">
                <el-col :span="6">
                    <el-form-item label-width="0px" prop="Name">
                        <el-input :disabled="readonly" placeholder="请输入业务名称" require v-model="trainingCategoryModel.Name" size="medium" class="input-width"> </el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="!readonly" :span="5">
                    <el-button size="medium" type="text" icon="el-icon-check" @click="saveCategoryName">保存</el-button>
                    <el-button size="medium" type="text" icon="el-icon-close" @click="cancelEdit">取消</el-button>
                </el-col>
            </el-form>
        </div>

    </div>
    <div v-for="price in trainingCategoryModel.TrainingPrices" :key="price.Guid" :name="price.Name">
        <trainingPriceDetail ref="trainingPriceDetail" :courseType="courseType" :readonly="readonly" :campusList="campusList" v-if="!isEditName" :dataIn="price" @remove="onRemoveCourse"></trainingPriceDetail>
    </div>
</div>
</template>

<style lang="scss" scoped>
.training-type-area {
    width: 800px;

    .input-width {
        font-size: 15px;
        width: 200px;
    }

    button {
        margin-left: 18px;
    }

    .delete-button {
        float: right;
        color: red;
    }
}
</style>

<script>
import trainingPriceDetail from "../priceManagement/trainingPriceDetail"
import {
    guid
} from "../../config/mUtils.js"
import {
    checkTrainingTermSetting
} from "../../service/termManage.service.js"
import {
    removeTrainingCategory
} from "../../service/globalPriceSetting.service.js"
export default {
    props: {
        readonly: Boolean,
        courseType: Number,
        campusList: Array,
        trainingCategory: {
            Guid: String,
            Id: Number,
            Name: String,
            CourseType: Number,
            TrainingPrices: []
        }
    },
    data() {
        return {
            trainingCategoryModel: {
                Guid: '',
                Id: 0,
                Name: '',
                CourseType: this.courseType,
                TrainingPrices: []
            },
            optionModel: {
                isReadonly: false
            },
            isEditName: false,
            originalCategoryName: '',
            rules: {
                Name: [{
                    required: true,
                    message: '请输入业务名称',
                    trigger: 'blur'
                }]
            }
        }
    },
    components: {
        trainingPriceDetail
    },
    created() {
        this.init();
    },
    computed: {
        mainCourseName() {
            return this.courseType === this.GLOBAL.courseType.newStudentGuide ? "课程" : "类别";
        }
    },
    methods: {
        init() {
            this.trainingCategoryModel.Guid = this.trainingCategory.Guid;
            this.trainingCategoryModel.Id = this.trainingCategory.Id;
            this.trainingCategoryModel.Name = this.trainingCategory.Name;
            this.trainingCategoryModel.CourseType = this.trainingCategory.CourseType;
            this.trainingCategoryModel.TrainingPrices = this.trainingCategory.TrainingPrices;
            if (this.trainingCategory.Id == 0) {
                this.isEditName = true;
            } else {
                this.isEditName = false;
            }
        },
        onRemoveCourse(course){
            if (!!this.trainingCategoryModel.TrainingPrices 
                && this.trainingCategoryModel.TrainingPrices.length > 0
                && !!course && !!course.Guid){
                let index = this.trainingCategoryModel.TrainingPrices.findIndex(i => i.Guid == course.Guid);
                this.trainingCategoryModel.TrainingPrices.splice(index, 1);
            }
        },
        onEditTypeName() {
            this.isEditName = true;
            this.originalCategoryName = this.trainingCategoryModel.Name
        },
        saveCategoryName() {
            let isValid = true;
            this.$refs.trainingCategoryForm.validate(valid => {
                isValid = valid;
            });
            if (!isValid)
                return;
            this.$emit("saveCategoryName", this.trainingCategoryModel);
        },
        cancelEdit() {
            this.isEditName = false;

            if (!!this.trainingCategoryModel.Id || !!this.originalCategoryName)
                this.trainingCategoryModel.Name = this.originalCategoryName;
            else
                this.$emit("remove", this.trainingCategory);
        },
        deleteCategory(){
            let message = "您确定要删除该业务";
            if (!!this.trainingCategoryModel.Name){
                message += " - " + this.trainingCategoryModel.Name;
            }
            this.$confirm(message +"吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                if (!!this.trainingCategoryModel.Id){
                    removeTrainingCategory(this.trainingCategoryModel.Id, this.courseType).then(result=>{
                        if (!!result && result.success){
                            this.$emit("remove", this.trainingCategory)
                        }else{
                            this.$message.error(result.message);
                        }
                    });
                }else{
                    this.$emit("remove", this.trainingCategory)
                }
            })
            .catch(()=>{});
        },
        addMainCourse() {
            switch (this.courseType) {
                case this.GLOBAL.courseType.english:
                case this.GLOBAL.courseType.newStudentGuide:
                    let newCourse = {
                        Guid: guid(),
                        Id: 0,
                        CourseId: 0,
                        TrainingCategoryId: this.trainingCategoryModel.Id,
                        Name: '',
                        Level: 1,
                        ParentId: null,
                        CoursePrice: 0,
                        HourPrice: 0,
                        RefundPrice: 0,
                        WeekCount:1,
                        Minutes:180,
                        SubTrainingPrice: []
                    }

                    if (this.courseType === this.GLOBAL.courseType.newStudentGuide) {
                        newCourse.IsHourPrice = false;
                    }

                    this.trainingCategoryModel.TrainingPrices.push(newCourse);
                    break;
                default:
                    checkTrainingTermSetting(this.trainingCategoryModel.Id).then(result => {
                        if (result && result.success) {
                            if (result.data == '') {
                                let newCourse = {
                                    Guid: guid(),
                                    Id: 0,
                                    CourseId: 0,
                                    TrainingCategoryId: this.trainingCategoryModel.Id,
                                    Name: '',
                                    Level: 1,
                                    ParentId: null,
                                    CoursePrice: 0,
                                    HourPrice: 0,
                                    RefundPrice: 0,
                                    WeekCount:1,
                                    Minutes:180,
                                    SubTrainingPrice: []
                                }
                                this.trainingCategoryModel.TrainingPrices.push(newCourse);
                            } else {
                                this.$message.error(result.data);
                            }
                        } else {
                            this.$message.error(result.message);
                        }
                    });
                    break;
            }
        },
        validatePrice() {
            let isValid = true;
            if (!!this.$refs.trainingPriceDetail) {
                this.$refs.trainingPriceDetail.forEach(element => {
                    isValid &= element.validatePrices();
                });
            }
            return isValid;
        },
        getDataModel() {
            let prices = [];
            if (!!this.$refs.trainingPriceDetail) {
                this.$refs.trainingPriceDetail.forEach(element => {
                    let model = element.getDataModel();
                    prices.push(model);
                });
            }
            this.trainingCategoryModel.TrainingPrices = prices; 
            return this.trainingCategoryModel;
        }
    },
    watch: {
        "trainingCategory.Id": function () {
            this.init();
        },
        "trainingCategory.Name": function () {
            this.init();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/trainingType.vue